/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：324
 */

"use strict"

export { RootPlayer as a }
var /* [auto-meaningful-name] */RootPlayer = "rootPlayer"
export default RootPlayer
